import { useEffect } from 'react';

import { UnsafePageDescription, UnsafePageTitle, UnsafePageWrapper } from '@style/pages/page.style';

import GithubIcon from '@asset/github.icon.svg?react';
import GoogleIcon from '@asset/google.icon.svg?react';
import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Text } from '@atom/typography/typography';
import { LoginProviderEnum } from '@enum/login-provider.enum';
import { ColorEnum } from '@enum/style/color.enum';
import { useSSOLogin } from '@hook/auth/use-sso-login.hook';
import { useLocalStorage } from '@hook/store/use-local-storage.hook';

import { ButtonSpace, ButtonTitle, Divider, FormWrapper, HaveUserParagraph } from './sign-up-velory.style';
import { useSignUp } from './use-sign-up-velory.hook';

export const SignUpVeloryPage = () => {
  const { onSignInPage } = useSignUp();
  const { handleLoginProvider } = useSSOLogin();
  const [, setVeloryCode] = useLocalStorage<boolean>('YynaGVxYpg8G');

  useEffect(() => setVeloryCode(true), []);

  return (
    <UnsafePageWrapper>
      <UnsafePageTitle>Create account</UnsafePageTitle>
      <UnsafePageDescription>Sign up with Google or Github below.</UnsafePageDescription>
      <FormWrapper>
        <ButtonSpace direction='vertical' size={16}>
          <Button
            icon={<GoogleIcon />}
            type={ButtonTypeEnum.Primary}
            block
            ghost
            onClick={handleLoginProvider(LoginProviderEnum.Google)}
          >
            <ButtonTitle>Sign up with Google</ButtonTitle>
          </Button>
          <Button
            icon={<GithubIcon />}
            type={ButtonTypeEnum.Primary}
            block
            ghost
            onClick={handleLoginProvider(LoginProviderEnum.Github)}
          >
            <ButtonTitle>Sign up with Github</ButtonTitle>
          </Button>
        </ButtonSpace>
        <Divider />
        <HaveUserParagraph>Already have an account</HaveUserParagraph>
        <Button type={ButtonTypeEnum.Primary} block ghost onClick={onSignInPage}>
          <Text color={ColorEnum.Black100} letterSpacing={1.4} level='m' weight={500}>
            LOG IN
          </Text>
        </Button>
      </FormWrapper>
    </UnsafePageWrapper>
  );
};
